import React from 'react';
import language from '../language';

const Statistics = ({ results, onRestart }) => {
    return (
        <div className="statistics">
            <h2>{language.statistics}</h2>
            <ul>
                {results.map((result, index) => (
                    <li key={index} className={result.isCorrect ? 'correct' : 'incorrect'}>
                        {result.question.question.question} - {result.isCorrect ? language.correct : language.incorrect}
                    </li>
                ))}
            </ul>
            <button onClick={onRestart}>{language.restartQuiz}</button>
        </div>
    );
};

export default Statistics;